
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.647 17.696H1.706a.843.843 0 01-.843-.843V1.357a.843.843 0 01.843-.843h11.259a.843.843 0 01.843.843v2.275","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M8.948 9.84a1.685 1.685 0 100-3.37 1.685 1.685 0 000 3.37zm3.607 3.564c-1.049-3.494-6.265-3.315-7.311.168","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M8.807 14.959a5.296 5.296 0 100-10.593 5.296 5.296 0 000 10.593zm3.746-1.556l1.683 1.689m-.866.868l1.728-1.73 3.173 3.174a1.224 1.224 0 11-1.73 1.73l-3.173-3.172.002-.003z","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    